export const MY_APPLICATIONS_REQUSET = 'MY_APPLICATIONS_REQUSET';
export const MY_APPLICATIONS_RECIEVE = 'MY_APPLICATIONS_RECIEVE';